export default "<h3>API Key Management</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n"